import { render, staticRenderFns } from "./ButtonFollowModel.vue?vue&type=template&id=1c12cf9c&scoped=true&"
import script from "./ButtonFollowModel.vue?vue&type=script&lang=js&"
export * from "./ButtonFollowModel.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFollowModel.vue?vue&type=style&index=0&id=1c12cf9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c12cf9c",
  null
  
)

component.options.__file = "ButtonFollowModel.vue"
export default component.exports